import { Injectable } from '@angular/core';
import { Comment } from './models/comment.model';
import { CommentsResponse } from './models/comments.response';
import { KeyedPaginatedResponse } from '../../../_core/models/keyed-paginated.response';

@Injectable({
  providedIn: 'root',
})
export class CommentsFactory {
  buildCommentFromCommentResponse(response: CommentsResponse): KeyedPaginatedResponse<Comment> {
    return {
      ...response,
      data: response.data.map((c) => ({
        ...c,
        replies: null,
      }))
    };
  }
}
